export default __webpack_public_path__ + "static/media/lock.5a118131.svg";